import { IModule, IModuleBuilder } from "app/IModule";
import { ProducersReducer, ProducerConfigurationReducer, ProducerBulkUploadResponseReducer } from "./producers.reducers";
import UploadProducersPage from "./UploadProducers.page"
import permissions from "common/security/permissions";

export default class ProducerModule implements IModule {
  build(builder: IModuleBuilder) {
    builder.addReducer("producers", new ProducersReducer());
    builder.addReducer("producerConfiguration", new ProducerConfigurationReducer());
    builder.addReducer("producerBulkUploadResponse", new ProducerBulkUploadResponseReducer());

    builder.addPermissionedRoute("/customers/bulk-import", permissions.CanManageAllCustomers, UploadProducersPage);
  }
}
